import { HelpDeskTicketsProvider } from "../context/HelpDeskTicketsContext";
import { Outlet } from "react-router-dom";

export function HelpDeskTicketsProviderWrapper() {
  return (
    <HelpDeskTicketsProvider>
      <Outlet />
    </HelpDeskTicketsProvider>
  );
}
